const HBS_BLOCK_PATTERNS: { pattern: RegExp; cssClass: string; labelFn: (match: string) => string }[] = [
    {
        pattern: /\{\{#if\s+(\w+)\}\}/g,
        cssClass: 'hbs-block hbs-if',
        labelFn: (_match: string) => {
            const varName = _match.replace(/\{\{#if\s+/, '').replace('}}', '');
            return `[IF: ${varName}]`;
        },
    },
    {
        pattern: /\{\{\/if\}\}/g,
        cssClass: 'hbs-block hbs-endif',
        labelFn: () => '[END IF]',
    },
    {
        pattern: /\{\{#each\s+(\w+)\}\}/g,
        cssClass: 'hbs-block hbs-each',
        labelFn: (_match: string) => {
            const varName = _match.replace(/\{\{#each\s+/, '').replace('}}', '');
            return `[REPEAT: ${varName}]`;
        },
    },
    {
        pattern: /\{\{\/each\}\}/g,
        cssClass: 'hbs-block hbs-endeach',
        labelFn: () => '[END REPEAT]',
    },
];

function isInsideTable(html: string, matchIndex: number): boolean {
    const before = html.slice(0, matchIndex);
    let depth = 0;
    const tagPattern = /<\/?table[\s>]/gi;
    let m: RegExpExecArray | null;
    while ((m = tagPattern.exec(before)) !== null) {
        if (m[0].startsWith('</')) depth--;
        else depth++;
    }
    return depth > 0;
}

export function handlebarsToVisual(html: string): string {
    let result = html;
    for (const { pattern, cssClass, labelFn } of HBS_BLOCK_PATTERNS) {
        const freshPattern = new RegExp(pattern.source, pattern.flags);
        let output = '';
        let lastIndex = 0;
        let match: RegExpExecArray | null;

        while ((match = freshPattern.exec(result)) !== null) {
            output += result.slice(lastIndex, match.index);
            const escaped = match[0].replace(/"/g, '&quot;');
            const label = labelFn(match[0]);

            if (isInsideTable(result, match.index)) {
                output += `<tr class="hbs-block-row"><td colspan="2"><span class="${cssClass}" contenteditable="false" data-hbs="${escaped}">${label}</span></td></tr>`;
            } else {
                output += `<span class="${cssClass}" contenteditable="false" data-hbs="${escaped}">${label}</span>`;
            }
            lastIndex = freshPattern.lastIndex;
        }
        output += result.slice(lastIndex);
        result = output;
    }
    return result;
}

export function visualToHandlebars(html: string): string {
    let result = html;
    // Table-wrapped block markers: <tr class="hbs-block-row"...><td...><span...data-hbs="...">...</span></td></tr>
    result = result.replace(
        /<tr[^>]*class="hbs-block-row"[^>]*>\s*<td[^>]*>\s*<span[^>]*data-hbs="([^"]*)"[^>]*>[^<]*<\/span>\s*<\/td>\s*<\/tr>/g,
        (_match, hbs) => hbs.replace(/&quot;/g, '"')
    );
    // Inline block markers (non-table context)
    result = result.replace(
        /<span[^>]*class="hbs-block[^"]*"[^>]*data-hbs="([^"]*)"[^>]*>[^<]*<\/span>/g,
        (_match, hbs) => hbs.replace(/&quot;/g, '"')
    );
    return result;
}
